import { Flex, FlexProps } from 'components'
import { createContext, useEffect, useState } from 'react'
import { useElementSize } from 'utils'

export interface IDimensionsContext {
  dimensions: { height: number; width: number }
}

export const DimensionsContext = createContext<IDimensionsContext>({} as IDimensionsContext)

export function DimensionsProvider(props: FlexProps) {
  const [dimensions, setDimensions] = useState({ height: 0, width: 0 })
  const { ref, height, width } = useElementSize<HTMLDivElement>()

  useEffect(() => {
    setDimensions({ height, width })
  }, [height, width])

  return (
    <DimensionsContext.Provider value={{ dimensions }}>
      <Flex ref={ref} flex={1} position="relative" overflow="hidden" {...props} />
    </DimensionsContext.Provider>
  )
}
